import * as React from 'react';

import ActionButton from 'components/buttons/action-button/ActionButton';
import { withModal } from 'components/modal/ModalHOC';
import InfluencerDeleteModal from 'components/influencer-tile/influencer-delete-button/modal/InfluencerDeleteModal';

import { __t, applyTranslations } from 'utils/language';

import type { TileStandard } from 'types';

applyTranslations(require('../tile-standard-footer.i18n.json'));

type Props = {
  creator: TileStandard,
  onDeleteProfile?: () => void
};

const Modal = withModal(<div />, {
  modalContent: InfluencerDeleteModal
});

const MSG_KEY = 'tile_standard_footer';

const TileStandardFooterDelete = (
  {
    creator,
    onDeleteProfile
  }: Props
): JSX.Element => (
  <div className="tile-standard-footer-delete">
    <Modal modalContentProps={{ influencer: creator, onDeleteProfile }}>
      <ActionButton
        color="tertiary"
      >
        {__t(`${MSG_KEY}.buttons.delete`)}
      </ActionButton>
    </Modal>
  </div>
);

export default TileStandardFooterDelete;
